import { MainLayoutVue } from "fs-pb-vue2/vueModels/layouts/MainLayoutVue";
import { ContractsApi } from "fs-pb-vue2/services/api/ContractsApi";
import { ContractModel } from "fs-pb-vue2/models/contracts/ContractModel";
import { CardModel } from "fs-pb-vue2/models/contracts/CardModel";

/**Модель представления авторизованной страницы */
export class MainLayoutVueGB extends MainLayoutVue {

  /**Инициализация стартовых данных приложения */
  async init(): Promise<void> {
  	this.contractsStore.addMethod(() => {
  		this.contractsStore.contracts.Contracts.map((contract: ContractModel) => {
        contract.StatementModel.isPeriod = true;
        if (contract.Cards.length > 0) {
          contract.Cards.map(async (card: CardModel) => {
            card.StatementModel.isPeriod = true;
            try {
              const res: any = await ContractsApi.getCardRest(card.Data.Id);
              if (res) {
                for (const key in res) {
                  if (res[key].Properties.SummaCode === 'AvailBalance') {
                    card.Data.Rest = res[key].Properties.CurrentSumma;
                  }
                }
              }
            } catch (e: any) {
              this.alertService.error(e.messsage);
            }
          });
        }
      });
  	});
    super.init();
    await this.personStore.fetchUserDocumentTypes();
    await this.configStore.fetchCurenccyRates();
    await this.personStore.fetchSubscriptions();
    await this.configStore.fetchQuiqOperationsAsync();
    await this.personStore.fetchRefrencesList(this.configStore.apiData.InquiriesFile);
    
  }

}
